import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { NAVIGATION } from 'constant/config'

import style from './index.module.scss'

const DATA = [
  NAVIGATION.my_casino,
  NAVIGATION.promotions
]

const Menu = () => {
  const { t } = useTranslation()

  return (
    <menu className={style.block}>
      {
        DATA.map((el, idx) =>
          <NavLink
            key={idx}
            to={el.url}
            end={el.url === NAVIGATION.my_casino.url}
            className={({ isActive }) =>
              `${style.link} ${isActive ? style.active : ''}`
            }
          >
            <span className={style.text}>
              {t(el.text)}
            </span>
          </NavLink>
        )
      }
    </menu>
  )
}

export default Menu
